// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"restaurant_wrapper__3kpN_","header":"restaurant_header__3FSbk","buttons":"restaurant_buttons__2EdFw","chartWrapper":"restaurant_chartWrapper__1C_BI"};